import React, { useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";

import Error from "../../containers/error";

export const Preload = (depsInstance, loadDepsAction, getIds) => {
  return (WrappedComponent) => {
    const Wrapper = (props) => {
      const depState = useSelector((state) => state.deps[depsInstance.name]);
      const dispatch = useDispatch();

      useEffect(() => {
        const ids = getIds(props);
        dispatch(loadDepsAction(ids));
      }, [JSON.stringify(getIds(props))]);

      if (depState.pending || !depState.loaded) {
        return <Loader active />;
      }
      if (depState.error) {
        return <Error error={depState.error} />;
      }

      return <WrappedComponent {...props} />;
    };

    return Wrapper;
  };
};
